import { Operation } from 'tokend-js-sdk'

export const DEFAULT_QUOTE_ASSET = 'BTC'
export const DEFAULT_PRECISION = String(Operation.ONE || 1000000).match(/0/g).length
export const DEFAULT_INPUT_STEP = `0.${'0'.repeat(DEFAULT_PRECISION - 1)}1`
export const DEFAULT_INPUT_MIN = `0.${'0'.repeat(DEFAULT_PRECISION - 1)}1`
export const DEFAULT_DATE_FORMAT = 'YYYY.MM.DD'
export const DEFAULT_DATE_TIME_FORMAT = 'YYYY.MM.DD HH:mm:ss'
export const DEFAULT_MAX_AMOUNT = Operation.MAX_INT64_AMOUNT
export const DEFAULT_SELECTED_ASSET = 'assets'
export const DEFAULT_CONVERSION_ASSET = 'USD'
export const DEFAULT_CONVERSION_PRESICION = 2
export const XPAY_NON_VISIBLE_TYPE = 1
export const WITHDRAWAL_TYPE_EMPTY = 'EMPTY'
export const WITHDRAWAL_TYPE_NOT_EMPTY = 'NOT_EMPTY'



// WEBPACK FOOTER //
// ./src/js/const/configs.const.js